// Mapping frontend delle categorie ai codici del piano dei conti (rispecchia backend/routes/contabilita.py)
export const CODICE_BOLLA = {
  Materiali: "60.02",
  "Materiali edili": "60.02",
  Subappalti: "60.03",
  Impianti: "60.08",
  Elettrici: "60.08",
  Idrici: "60.08",
  Condizionamento: "60.08",
  Finiture: "60.09",
  Porte: "60.09",
  Serramenti: "60.09",
  Ferramenta: "60.10",
  Attrezzature: "60.10",
  Trasporti: "60.05",
  Noleggi: "60.04",
  Sicurezza: "60.06",
  Altro: "60.99",
};

export const CODICE_COSTO_FISSO = {
  stipendi_amministrativi: "62.01",
  affitti: "62.02",
  utenze: "62.03",
  assicurazioni: "62.04",
  consulenze: "62.05",
  commercialista: "62.05",
  software: "62.06",
  licenze: "62.06",
  telefonia: "62.07",
  mezzi_aziendali: "62.08",
  manutenzioni: "62.08",
  leasing: "62.09",
  noleggi: "62.09",
  finanziamenti: "62.10",
  pubblicita: "62.11",
  sicurezza: "62.12",
  formazione: "62.12",
  imposte: "62.13",
  altri: "62.99",
};

export const CODICE_MANODOPERA = "60.01"; // rapportini → manodopera diretta
export const CODICE_RICAVI = "70.01";
export const CODICE_CREDITI = "40.01";
export const CODICE_DEBITI = "42.01";

export const codiceBolla = (categoria) => CODICE_BOLLA[categoria] || "60.99";
export const codiceCostoFisso = (categoria) => CODICE_COSTO_FISSO[categoria] || "62.99";
